import { User } from '../_model/user/user.model';
import { Injectable } from "@angular/core";

@Injectable()
export class UserTransFormer {
    fromGetUserInfo(user): User {

        const result = new User(false);
        result.id = '';
        result.name = '';
        result.accountName = '';
        result.nickname = user.nickName;
        result.gender = user.who === '他' ? 'male' : (user.who === '她' ? 'female' : '');
        result.avatar = user.headimg;
        result.background = user.background;
        result.experience = user.experience;
        result.expToNextLevel = user.nextLevel;
        result.level = user.currentLevel;
        result.dnCoins = user.gold;
        result.membership = this.getUserRoleFromImage(user.userLevelPic);
        result.membershipExpiryDate = user.EndDate;
        result.roleId = user.GID;
        result.daysOfMembership = 0;
        result.region = user.from;
        result.lastLogin = '';
        result.lastIP = '';
        result.loginTimes = 0;
        result.permissions = [];
        result.key = user.key;
        result.privateFolder = {
            available: false,
            secret: '',
            securityMode: 'password',
        };
        result.token = {
            expire: '',
            gid: null,
            sign: '',
            token: '',
        };
        // result.notifications = {
        //     favorites: user.scjNum,
        //     messages: user.messageNum
        // };
        result.trendCount = user.trendCount ? user.trendCount : 0;
        result.lastTrend = user.lastTrend;
        return result;
    }

    fromGetAuthorizedUserInfo(user): User {
        const result = new User(true);
        if(user)
        {
            result.id = user.uid;
            result.name = user.userName;
            result.accountName = user.userNameRaw;
            result.nickname = user.nickName;
            result.avatar = user.headImage;
            result.background = user.background;
            result.gender = user.sex === 1 ? 'male' : (user.sex === 0 ? 'female' : '');
            result.region = user.from;
            result.experience = user.experience;
            result.expToNextLevel = user.nextLevel;
            result.level = user.userLevel;
            result.dnCoins = user.gold;
            result.daysOfMembership = user.endDays;
            result.membership = this.getUserRoleFromImage(user.vipImage);
            result.membershipExpiryDate = user.endDate;
            result.roleId = user.gid;
            result.lastLogin = user.lastTime;
            result.lastIP = user.lastIP;
            result.loginTimes = user.loginNumber;
            result.permissions = [];
            result.registerDate = user.sDate;
            result.privateFolder = {
                available: false,
                secret: '',
                securityMode: 'password',
            };
            result.token = {
                expire: '',
                gid: null,
                sign: '',
                token: '',
            };
            // result.notifications = {
            //     favorites: user.scjNum ? user.scjNum : 0,
            //     messages: user.messageNum ? user.messageNum : 0
            // };
            result.officalUp = user.isOfficalUP ? user.isOfficalUP : false;
            result.isOfficalSpeaker = user.isOfficalSpeaker ? user.isOfficalSpeaker : false;
            result.colorGuideDone = user.colorGuideDone ? user.colorGuideDone : 1;
            result.signature = user.signature;
            result.isBindTel = user.isBindTelphone ? user.isBindTelphone : false;
            result.autoSendServiceMsgUids = user.autoSendServiceMsgUids;
            result.trendNum = user.trendNum ? user.trendNum : 0;
            result.albumNum = user.albumNum ? user.albumNum : 0;
            result.smallVideoNum = user.smallVideoNum ? user.smallVideoNum : 0;
            result.videoNum = user.videoNum ? user.videoNum : 0;
            result.userKey = user.key ? user.key : '';
        }
        
        return result;
    }

    fromValidateToken(user): User {
        const result = new User(true);
        result.autoKey = user.autoLoginKey;
        result.id = user.userToken.uid;
        result.name = user.userName;
        result.accountName = user.userName;
        result.nickname = user.nickName;
        result.avatar = undefined;
        result.gender = '';
        result.region = user.from;
        result.experience = 0;
        result.expToNextLevel = 0;
        result.level = null;
        result.dnCoins = null;
        result.daysOfMembership = null;
        result.membership = null;
        result.membershipExpiryDate = null;
        result.roleId = user.gid;
        result.lastLogin = null;
        result.lastIP = null;
        result.loginTimes = null;
        result.permissions = [];
        result.privateFolder = {
            available: undefined,
            secret: undefined,
            securityMode: undefined,
        };
        result.token = {
            expire: user.userToken.expire,
            gid: user.userToken.gid,
            sign: user.userToken.sign,
            token: user.userToken.token,
        };
        // result.notifications = {
        //     favorites: user.scjNum,
        //     messages: user.messageNum
        // };
        return result;
    }

    getUserRoleFromImage(imagePath) {
        switch (true) {
            case imagePath.indexOf('royal-vvvip.png') !== -1:
                return 'royalVip';
            case imagePath.indexOf('royal-admin.png') !== -1:
                return 'royalAdmin';
            case imagePath.indexOf('normal-vip.png') !== -1:
                return 'vip';
            case imagePath.indexOf('g-VIP.png') !== -1:
                return 'gvip';
            case imagePath.indexOf('et-VIP.png') !== -1:
                return 'etvip';
            case imagePath.indexOf('cpvip.png') !== -1:
                return 'cpvip';
            case imagePath.indexOf('editor.png') !== -1:
                return 'editor';
            default:
                return '';
        }
    }
}
